import React from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'

// Import Components
import { LeftRail } from './LeftRail'
import { Sections } from './Sections'

// Styled components via Emotion
const BodyContainer = styled.div`
	display: block;
	height: 100%;
	margin: 100px auto 100px auto;
	width: 90%;

	${({ theme }) => theme.MQ.M} {
		display: flex;
		margin: 50px auto 100px auto;
	}

	${({ theme }) => theme.MQ.XL} {
		${({ theme }) => theme.maxWidth.L};
		width: 100%;
	}
`

const CategorySections = styled.div`
	color: ${({ theme }) => theme.colors.text};
	font-weight: 300;
	position: relative;
	height: 100%;
	width: 100%;

	${({ theme }) => theme.MQ.L} {
		${({ isTocPresent }) => (isTocPresent ? `max-width: 975px; width: 80%;` : `width: 100%;`)}
	}
`
CategoryBody.propTypes = {
	guid: string.isRequired,
	sections: array.isRequired,
	title: string.isRequired,
	tocElements: array.isRequired,
	widgetId: string,
}

export function CategoryBody(props) {
	const { docType, guid, sections, title, tocElements, widgetId: categoryWidgetId } = props

	return (
		<BodyContainer id="top-of-toc">
			<LeftRail tocElements={tocElements} docType={docType} />
			<CategorySections isTocPresent={tocElements.length !== 0}>
				<Sections catTitle={title} categoryWidgetId={categoryWidgetId} guid={guid} sections={sections} />
			</CategorySections>
		</BodyContainer>
	)
}
